module.exports = __webpack_public_path__ + "c08d6da5a11d785e6338efd6737938fe.svg";